import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_NAME__TERMINALS = 'terminals';

export interface TerminalListReduxState {
  type?: string;
  loading: boolean;
  errorWrapper?: ErrorWrapper;
}

const defaultState: TerminalListReduxState = {
  loading: false,
};

export default (
  state: TerminalListReduxState = defaultState,
  action: Action,
): TerminalListReduxState => {
  return state;
};
